import type { SVGProps } from "react";

export function ENSNodeIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="1"
        y="1"
        width="26"
        height="26"
        rx="3"
        fill="#528BFF"
        stroke="black"
        strokeWidth="2"
      />
      <path
        d="M8.1168 12.4324C8.29905 12.8207 8.7507 13.5893 8.7507 13.5893L13.9408 5.00781L8.86956 8.54183C8.56846 8.73992 8.32282 9.01726 8.14849 9.33421C7.68099 10.3088 7.67307 11.4419 8.1168 12.4324Z"
        fill="url(#paint0_linear_689_31)"
      />
      <path
        d="M6.05691 15.2533C6.17576 16.9173 6.99984 18.4466 8.32311 19.4529L13.9252 23.3593C13.9252 23.3593 10.4229 18.3039 7.45942 13.2802C7.15831 12.7494 6.96022 12.1709 6.86513 11.5687C6.82551 11.2993 6.82551 11.022 6.86513 10.7446C6.7859 10.8873 6.63534 11.1804 6.63534 11.1804C6.33424 11.7906 6.12822 12.4482 6.03313 13.1218C5.98559 13.827 5.98559 14.5481 6.05691 15.2533Z"
        fill="white"
      />
      <path
        d="M20.3513 15.935C20.1691 15.5467 19.7174 14.7781 19.7174 14.7781L14.5273 23.3596L19.5907 19.8255C19.8918 19.6274 20.1374 19.3501 20.3117 19.0332C20.7871 18.0506 20.7951 16.9175 20.3513 15.935Z"
        fill="url(#paint1_linear_689_31)"
      />
      <path
        d="M22.4118 13.106C22.2929 11.442 21.4689 9.91276 20.1456 8.90643L14.5435 5C14.5435 5 18.0458 10.0554 21.0093 15.0791C21.3104 15.61 21.5085 16.1884 21.6036 16.7906C21.6432 17.06 21.6432 17.3374 21.6036 17.6147C21.6828 17.4721 21.8334 17.1789 21.8334 17.1789C22.1345 16.5687 22.3405 15.9111 22.4356 15.2376C22.4831 14.5323 22.4831 13.8192 22.4118 13.106Z"
        fill="white"
      />
      <path
        d="M8.14879 9.33421C8.32311 9.01726 8.56875 8.73992 8.86986 8.54183L13.9332 5.00781L8.74307 13.5893C8.74307 13.5893 8.29142 12.8207 8.10917 12.4324C7.66544 11.4419 7.68129 10.3088 8.14879 9.33421ZM6.05691 15.2533C6.17576 16.9173 6.99984 18.4466 8.32311 19.4529L13.9252 23.3593C13.9252 23.3593 10.4229 18.304 7.45942 13.2803C7.15831 12.7494 6.96022 12.1709 6.86513 11.5687C6.82551 11.2993 6.82551 11.022 6.86513 10.7446C6.7859 10.8873 6.63534 11.1805 6.63534 11.1805C6.33424 11.7906 6.12822 12.4483 6.03313 13.1218C5.98559 13.827 5.98559 14.5481 6.05691 15.2533ZM20.3435 15.9347C20.1613 15.5465 19.7096 14.7779 19.7096 14.7779L14.5274 23.3593L19.5908 19.8253C19.8919 19.6272 20.1375 19.3499 20.3118 19.0329C20.7793 18.0583 20.7952 16.9252 20.3435 15.9347ZM22.4037 13.1139C22.2849 11.4499 21.4608 9.92057 20.1375 8.91425L14.5433 5.00781C14.5433 5.00781 18.0456 10.0632 21.0091 15.0869C21.3102 15.6178 21.5083 16.1962 21.6034 16.7984C21.643 17.0678 21.643 17.3452 21.6034 17.6225C21.6826 17.4799 21.8332 17.1867 21.8332 17.1867C22.1343 16.5766 22.3403 15.9189 22.4354 15.2454C22.4909 14.5322 22.4909 13.8191 22.4196 13.1059L22.4037 13.1139Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_689_31"
          x1="14.1617"
          y1="5.21238"
          x2="7.49928"
          y2="12.4349"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.58" stopColor="#A0A8D4" />
          <stop offset="0.73" stopColor="#8791C7" />
          <stop offset="0.91" stopColor="#6470B4" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_689_31"
          x1="14.3054"
          y1="23.1506"
          x2="20.9688"
          y2="15.9294"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.58" stopColor="#A0A8D4" />
          <stop offset="0.73" stopColor="#8791C7" />
          <stop offset="0.91" stopColor="#6470B4" />
        </linearGradient>
      </defs>
    </svg>
  );
}
